/* OPA blog post enhancements: reading progress, "On this page", key-takeaways callout, FAQ cards, scrollable tables. */
(function () {
  var article = document.querySelector('.hdt-article-content article');
  if (!article) return;

  // Reading progress
  var bar = document.querySelector('.opa-progress span');
  if (bar) {
    var tick = function () {
      var r = article.getBoundingClientRect();
      var total = r.height - window.innerHeight;
      var done = Math.min(Math.max(-r.top, 0), Math.max(total, 1));
      bar.style.width = (total > 0 ? (done / total) * 100 : 0) + '%';
    };
    window.addEventListener('scroll', tick, { passive: true });
    tick();
  }

  var slug = function (s) {
    return s.toLowerCase().replace(/[^a-z0-9\s-]/g, '').trim().replace(/\s+/g, '-').slice(0, 60);
  };
  var text = function (el) { return (el.textContent || '').replace(/\s+/g, ' ').trim(); };

  // Key takeaways: a "Short Summary" / "Key Takeaways" heading and the list that follows it
  var heads = article.querySelectorAll('h2, h3, h4, p');
  for (var i = 0; i < heads.length; i++) {
    var h = heads[i];
    if (!/^(short summary|key takeaways|summary of key points)$/i.test(text(h))) continue;
    var list = h.nextElementSibling;
    while (list && !/^(UL|OL)$/.test(list.tagName) && text(list) === '') list = list.nextElementSibling;
    if (!list || !/^(UL|OL)$/.test(list.tagName)) continue;
    var box = document.createElement('div');
    box.className = 'opa-takeaways';
    h.parentNode.insertBefore(box, h);
    box.appendChild(h);
    box.appendChild(list);
    break;
  }

  // FAQ cards: questions (h3 ending in "?") after a "Frequently Asked Questions" heading
  var h2s = article.querySelectorAll('h2');
  for (var j = 0; j < h2s.length; j++) {
    if (!/frequently asked|faq/i.test(text(h2s[j]))) continue;
    var el = h2s[j].nextElementSibling;
    while (el && el.tagName !== 'H2') {
      if (el.tagName === 'H3' && /\?\s*$/.test(text(el))) {
        var ans = el.nextElementSibling;
        if (ans && ans.tagName === 'P') { el.classList.add('opa-faq-q'); ans.classList.add('opa-faq-a'); }
      }
      el = el.nextElementSibling;
    }
    break;
  }

  // Scrollable tables
  article.querySelectorAll('table').forEach(function (t) {
    if (t.parentNode.classList.contains('opa-table-wrap')) return;
    var w = document.createElement('div');
    w.className = 'opa-table-wrap';
    t.parentNode.insertBefore(w, t);
    w.appendChild(t);
  });


  // Accessible names for icon-only theme links (back to blog, recent-post image links)
  document.querySelectorAll('.hdt-main-section__article a').forEach(function (a) {
    if (text(a) || a.getAttribute('aria-label') || a.querySelector('img[alt]:not([alt=""])')) return;
    if (a.classList.contains('hdt-current-blog')) { a.setAttribute('aria-label', 'Back to blog'); return; }
    var card = a.closest('.hdt-article-inner, .hdt-main-article-item, li, article');
    var t = card && card.querySelector('h2, h3, h4, .hdt-article-title');
    a.setAttribute('aria-label', t && text(t) ? text(t) : 'Read article');
  });

  // On this page
  var sections = Array.prototype.filter.call(article.querySelectorAll('h2'), function (h) { return text(h).length > 2; });
  if (sections.length >= 3) {
    var used = {};
    var ol = document.createElement('ol');
    sections.forEach(function (h) {
      var id = h.id || slug(text(h)) || 'section';
      while (used[id] || (document.getElementById(id) && document.getElementById(id) !== h)) id += '-2';
      used[id] = true;
      h.id = id;
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + id;
      a.textContent = text(h);
      li.appendChild(a);
      ol.appendChild(li);
    });
    var toc = document.createElement('details');
    toc.className = 'opa-toc';
    if (window.matchMedia('(min-width: 990px)').matches) toc.open = true;
    var sum = document.createElement('summary');
    sum.textContent = 'On this page';
    toc.appendChild(sum);
    toc.appendChild(ol);
    var anchor = article.querySelector('.opa-takeaways') || sections[0];
    if (anchor.classList && anchor.classList.contains('opa-takeaways')) anchor.parentNode.insertBefore(toc, anchor.nextSibling);
    else anchor.parentNode.insertBefore(toc, anchor);
  }
})();
